const BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:3001";

/** Join backend base URL with a relative API path from the server. */
export function resolveApiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  // Document previews are served by Next.js (mock mode), not the API backend.
  if (path.startsWith("/documents/")) {
    return path;
  }
  const base = BASE_URL.replace(/\/$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}
